import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EdlCommonComponentsModule, EdlCommonPipesModule, EdlDatePickerModule } from "@edl-development/edl-common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LaddaModule } from "angular2-ladda";
import { PipesModule } from "../pipes/pipes.module";
import { TimeTrackingComponent } from "./components/time-tracking-form/time-tracking-form.component";
import { TimeTrackingFormService } from "./services/time-tracking-form/time-tracking-form.service";
import { TimeTrackingSummaryComponent } from './components/time-tracking-summary/time-tracking-summary.component';
import { TimeTrackingHelperService } from "./services/time-tracking-helper/time-tracking-helper.service";
import { UserTimeTrackingFormService } from "./services/user-time-tracking-form/user-time-tracking-form.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        LaddaModule,
        EdlCommonPipesModule,
        PipesModule,
        EdlCommonComponentsModule,
        EdlDatePickerModule
    ],
    providers: [
        TimeTrackingFormService,
        TimeTrackingHelperService,
        UserTimeTrackingFormService 
    ],
    declarations: [
        TimeTrackingComponent,
        TimeTrackingSummaryComponent
    ],
    exports: [
        TimeTrackingComponent,
        TimeTrackingSummaryComponent
    ]
})
export class EdlTimeTrackingModule {}